// 版本比较
export const isHigherVersion = (curVersion: string, targetVersion: string): boolean => {
  function formatVersionStr(versionStr: string): string {
    const realVersionStr = versionStr.split('-')[0];
    return `${realVersionStr}`.split('.').length < 3
      ? `${realVersionStr}`.concat('.0')
      : `${realVersionStr}`;
  }
  const curVersionFormatStr = formatVersionStr(curVersion);
  const targetVersionFormatStr = formatVersionStr(targetVersion);

  function toNum(arr: string) {// string 转 number
    const c = arr.toString().split('.');// [4, 5, 0][4, 54, 0]
    const num_place = ['0000', '000', '00', '0', ''];
    for (let i = 0; i < c.length; i++) {
      const len = c[i].length;
      c[i] = num_place[len] + c[i];
    }
    return c.join('');
  }

  // 检测版本号是否需要更新
  function checkPlugin(a: string, b: string) {// 4.5.0 4.54.0
    const numA = toNum(a);
    const numB = toNum(b);
    return numA >= numB;
  }
  return checkPlugin(curVersionFormatStr, targetVersionFormatStr);
};
